module.exports = __webpack_public_path__ + "img/United Bank for Africa.e9adbc0e.png";